// Service Worker registration and update handling
export const register = (onUpdate?: () => void) => {
  // Check if we're in production based on the hostname
  const isProduction =
    window.location.hostname === 'ibdrant.com' ||
    window.location.hostname === 'www.ibdrant.com'
  // Only register service worker in production and if it's a secure context
  if (!isProduction || !('serviceWorker' in navigator)) {
    console.log('⚠️ Service Worker not registered (not production domain)')
    return
  }
  // Check for secure context (HTTPS)
  if (!window.isSecureContext) {
    console.warn(
      '⚠️ Service Worker not registered (site must be served over HTTPS)',
    )
    return
  }
  window.addEventListener('load', () => {
    const swUrl = '/service-worker.js'
    navigator.serviceWorker
      .register(swUrl, {
        type: 'module',
        updateViaCache: 'none',
      })
      .then((registration) => {
        console.log(
          '✅ Service Worker registered successfully:',
          registration.scope,
        )
        // Check for updates every 60 seconds
        setInterval(() => {
          registration.update()
        }, 60000)
        // Listen for updates
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              if (
                newWorker.state === 'installed' &&
                navigator.serviceWorker.controller
              ) {
                // New service worker available
                console.log('🔄 New version available!')
                if (onUpdate) {
                  onUpdate()
                }
              }
            })
          }
        })
      })
      .catch((error) => {
        // Silently fail - app continues to work without service worker
        console.log('ℹ️ Service Worker not available:', error.message)
        // Don't throw error or show alert - this is expected in some deployment scenarios
      })
  })
}
export const unregister = () => {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister()
        console.log('Service Worker unregistered')
      })
      .catch((error) => {
        console.error('Error unregistering service worker:', error)
      })
  }
}
export const skipWaiting = () => {
  if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
    navigator.serviceWorker.controller.postMessage({ type: 'SKIP_WAITING' })
  }
}
